// @flow

import React from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";
import { route } from "@routes/helper";
import {
  Button,
  View,
  OrganizationHierarchyTree,
  withFocusFirstInput,
  SwitchButton,
  Text,
} from "@components";
import { formatDateTime } from "@transformers/date";
import "./current-hierarchy.style.scss";

const noop = () => undefined;

type PropsFromState = $Exact<{
  tree: Object,
  clientId: number,
  className?: string,
  onExport: () => void,
  onExportDetailed: () => void,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  showEmployees: boolean,
}>;

export class CurrentHierarchy extends React.Component<Props, OwnState> {
  state = {
    showEmployees: true,
    showLeavers: false,
  };

  handleBranchClick = (branch: Object) => {
    if (branch.data.employeeId) {
      window.open(
        route("REPORTING_EMPLOYEE_DETAILS_PATH", {
          clientId: this.props.clientId,
          employeeId: branch.data.employeeId,
        }),
        "_blank",
      );
    }
  };

  handleEmployeesToggle = () => {
    this.setState(prev => ({
      ...prev,
      showEmployees: !prev.showEmployees,
    }));
  };

  handleLeaversToggle = () => {
    this.setState(prev => ({
      ...prev,
      showLeavers: !prev.showLeavers,
    }));
  };

  getCreatedBy = (data: Object) =>
    data.createdBy ? `${data.createdBy.firstName} ${data.createdBy.lastName}` : "-";

  render() {
    return (
      <View gap={3} className={classNames("current-hierarchy", this.props.className)}>
        <View direction="row" justifyContent="space-between" alignItems="center">
          <Text type="h6">{this.props.t("CURRENT_HIERARCHY")}</Text>
          <Button materialIcon="file_download" onClick={this.props.onExportDetailed} size="small">
            {this.props.t("EXPORT")}
          </Button>
        </View>

        <View direction="row" separator="top" padding={[3, 0, 0, 0]} justifyContent="space-between">
          {/* Date Published */}
          <View alignItems="start">
            <span className="text-color-charcoal">{this.props.t("PUBLISHED_DATE")}</span>
            <p>{this.props.tree.createdAt ? formatDateTime(this.props.tree.createdAt) : "-"}</p>
          </View>

          {/* Published By */}
          <View alignItems="start">
            <span className="text-color-charcoal">{this.props.t("PUBLISHED_BY")}</span>
            <p>{this.getCreatedBy(this.props.tree)}</p>
          </View>

          {/* Show Employees */}
          <View direction="row" alignItems="center" gap={3}>
            <span className="text-color-charcoal">{this.props.t("SHOW_EMPLOYEES")}</span>
            <SwitchButton active={this.state.showEmployees} onChange={this.handleEmployeesToggle}>
              {this.props.t(this.state.showEmployees ? "ON" : "OFF")}
            </SwitchButton>
          </View>

          {/* Show Leavers */}
          <View direction="row" alignItems="center" gap={3}>
            <span className="text-color-charcoal">{this.props.t("SHOW_LEAVERS")}</span>
            <SwitchButton active={this.state.showLeavers} onChange={this.handleLeaversToggle}>
              {this.props.t(this.state.showLeavers ? "ON" : "OFF")}
            </SwitchButton>
          </View>
        </View>
        <View className="current-hierarchy-container bordered">
          <OrganizationHierarchyTree
            tree={this.props.tree.structure}
            disabled={true}
            searchable={true}
            expanded={[]}
            onDrop={noop}
            onAction={noop}
            onClick={this.handleBranchClick}
            searchPlaceholder={this.props.t("FIND_DEPARTMENT")}
            showDisabled={true}
            showEmployees={this.state.showEmployees}
            showLeavers={this.state.showLeavers}
          />
        </View>
      </View>
    );
  }
}

export default localize()(withFocusFirstInput(CurrentHierarchy));
